import { useState } from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useAuth } from '../../../shared/ui';
import { AppHeaderWithLanguage } from '../components/AppHeaderWithLanguage';
import { AppFooterWithLanguage } from '../components/AppFooterWithLanguage';
import { AppSidebar } from '../components/AppSidebar';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const { isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="app-layout">
      <AppHeaderWithLanguage
        menuOpen={menuOpen}
        onToggleMenu={() => setMenuOpen(open => !open)}
      />
      {isAuthenticated ? (
        <div className="mc-shell">
          <AppSidebar open={menuOpen} onNavigate={closeMenu} />
          {menuOpen && <div className="mc-backdrop" onClick={closeMenu} />}
          <main className="mc-content">
            <div className="mc-page">
              <Outlet />
            </div>
            <AppFooterWithLanguage />
          </main>
        </div>
      ) : (
        <>
          <main className="app-layout__main">
            <Outlet />
          </main>
          <AppFooterWithLanguage />
        </>
      )}
    </div>
  );
}
